import React from 'react';
import { useTranslate } from 'react-redux-multilingual'
import { Accordion } from "react-bootstrap";
import EachNotification from './EachNotification';

const PosNotifConf = (props) =>{
    const t = useTranslate();

    if(props.moduleAdmin.params.pos.active){
        return (
            <Accordion className='mb-2'>
                <Accordion.Item eventKey='cashRegister'>
                    <Accordion.Header>
                        <span style={{color:props.notificationsType.cashRegister.bg, fontWeight:'bold',fontSize:'0.9rem'}}>
                            {t('cashRegister')}&nbsp;
                            <i style={{color:props.notificationsType.cashRegister.bg}} className={`${props.notificationsType.cashRegister.icon} header-icon fs-5`}></i>
                        </span>
                    </Accordion.Header>
                    <Accordion.Body>
                        <>
                             <EachNotification  allUsers={props.allUsers} sectionId={props.sectionId} notifState={props.notifState} setNotifState={props.setNotifState} typeNotif="error_open_checkout" bgcolor="#ffffc3" disabled={props.disabled} setDisabled={props.setDisabled}/>
                             <EachNotification  allUsers={props.allUsers} sectionId={props.sectionId} notifState={props.notifState} setNotifState={props.setNotifState} typeNotif="error_close_checkout" bgcolor="#cedbfb" disabled={props.disabled} setDisabled={props.setDisabled}/>
                             <EachNotification  allUsers={props.allUsers} sectionId={props.sectionId} notifState={props.notifState} setNotifState={props.setNotifState} typeNotif="stockAdjustment" bgcolor="#ffffc3" disabled={props.disabled} setDisabled={props.setDisabled}/>
                             <EachNotification  allUsers={props.allUsers} sectionId={props.sectionId} notifState={props.notifState} setNotifState={props.setNotifState} typeNotif="itemCreation" bgcolor="#cedbfb" disabled={props.disabled} setDisabled={props.setDisabled}/>
                        </>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        )
    }else{
        return(<></>)
    }
};

export default PosNotifConf;